import React, { useContext } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Context as ConfigContext } from '../Config';
import WithTitle from '../toolkit/WithTitle';
import usePageClassName from '../hooks/usePageClassName';
import useTranslation from '../hooks/useTranslation';
import useSearchPageData from '../hooks/useSearchPageData';
import ErrorPage from './error';

type Props = RouteComponentProps<{}>;

const SearchPage: React.FC<Props> = ({}) => {
  const { t } = useTranslation();
  usePageClassName('search-page');
  const { fetchingStatus, searchTerm } = useSearchPageData();
  const { pages, pageLoadingIndicator: Loader } = useContext(ConfigContext);

  if (fetchingStatus === 'is-fetching' || fetchingStatus === 'not-started')
    return <Loader />;
  if (fetchingStatus !== 'has-fetched') return <ErrorPage />;

  const title = t('pageTitles.search', { searchTerm });

  const Page = pages.search?.component;
  const searchPage = Page ? <Page /> : <></>;

  return <WithTitle title={title}>{searchPage}</WithTitle>;
};
SearchPage.displayName = 'SearchPage';

export default SearchPage;
